module.exports = __webpack_public_path__ + "static/media/menu-settings.93f86504.svg";